<template>
  <div class="root" @click="$emit('viewsignals')">
    <span
      class="time-text"
      v-if="formatDate(lastOnline) !== '0 m' && !!formatDate(lastOnline)"
    >
      {{ formatDate(lastOnline) }}</span
    ><span v-else-if="!!formatDate(lastOnline)" class="time-text now-color">
      now
    </span>
    <div
      @mouseenter="showPopUp = true"
      @mouseleave="showPopUp = false"
      :class="{
        'pokemon-ball-red': successStatus === 'LOSS',
        'pokemon-ball-green': successStatus === 'WIN',
        'pokemon-ball-half': successStatus === 'WIN_LOSS',
        'pokemon-ball-none': successStatus === null
      }"
    >
      <span v-if="client" class="poke"><span class="online"></span></span>
      <span v-else class="poke"
        ><span
          class="offline"
          :class="{
            'missed-call': clientObj.missedScheduledCall,
            'ca-coming': clientObj.scheduledCallSoon
          }"
        ></span
      ></span>
    </div>
    <div
      v-if="showPopUp && (lastOnline || (win !== null || loss !== null))"
      class="popup-content"
    >
      <span>
        <span v-if="lastOnline"
          ><img class="mini-flag" src="img/flags/gb.png" />
          <span class="time-text-sig"> {{ formatDateTable(lastOnline) }}</span>
          <img class="mini-flag-il" src="img/flags/il.png" />
          <span class="time-text-sig"> {{ addIlTime(lastOnline) }} </span>
          <span v-if="win !== null && loss !== null"> | </span>
        </span>
        <span class="loss"> {{ loss }} </span>
        <span v-if="win !== null && loss !== null"> | </span>
        <span class="win"> {{ win }} </span>
      </span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { Globals } from "../../../../../global_constants/constants";

export default {
  name: "ClientOnline",
  props: {
    client: {
      required: true
    },
    clientObj: {
      required: true
    },
    lastOnline: {
      required: false
    },
    signalsStatus: {
      type: Object
    },
    contactValue: {
      type: String
    }
  },
  data() {
    return {
      CMSClientSignals: {},
      successStatus: null,
      showPopUp: false,
      win: null,
      loss: null
    };
  },
  created() {
    this.calculateSuccess();
  },
  methods: {
    calculateSuccess() {
      if (Globals.cms.signals_stats === true) {
        axios
          .post(
            `${Globals.joomla_website}api_evo_crm/user-statistics.php?token=151190&email=${this.contactValue}`
          )
          .then(res => {
            let endedSignals = res.data.ended_signals;
            if (endedSignals !== undefined && endedSignals !== null) {
              endedSignals = endedSignals.slice(0, 10);
              const loss = endedSignals.filter(item => item.success !== "WIN");
              const win = endedSignals.filter(item => item.success !== "LOSS");
              this.loss = loss.length;
              this.win = win.length;
              if (loss.length > win.length) {
                this.successStatus = "LOSS";
              }

              if (loss.length < win.length) {
                this.successStatus = "WIN";
              }

              if (loss.length === win.length) {
                this.successStatus = "WIN_LOSS";
              }
            } else {
              this.successStatus = null;
            }
          });
      }
    },
    formatDateTable(date) {
      if (!date) {
        return "";
      }
      return moment(String(date)).format("HH:mm DD/MM/YY");
    },

    addIlTime(date) {
      return moment(moment(date).add("hours", 2)).format("HH:mm DD/MM/YY");
    },
    formatDate(date) {
      const now = moment().subtract(2, "hours");
      const end = moment(String(date));
      const diff = now.diff(end, "minutes");
      if (diff < 60 && diff >= 0) {
        return diff + " m";
      }
      if (diff > 60) {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.root {
  float: right;
  cursor: pointer;
  position: relative;
}

.poke {
  height: 0.88em;
  width: 0.88em;
  background-color: white;
  /* border-radius: 50%; */
  position: absolute;
  top: 0.2em;
  left: 0.2em;
  border-right: 1px;
}

.online {
  height: 0.7em;
  width: 0.7em;
  background-color: #008b00;
  /* border-radius: 50%; */
  position: absolute;
  margin: auto;
  top: 0.1em;
  left: 0.1em;
  animation: flash 2s linear infinite;
}

.offline {
  height: 0.7em;
  width: 0.7em;
  background-color: grey;
  /*border-radius: 50%;*/
  position: absolute;
  margin: auto;
  top: 0.1em;
  left: 0.1em;
}

@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

.time-text {
  font-size: 9px;
  position: absolute;
  width: max-content;
  right: 13px;
  top: 4px;
}

.pokemon-ball-red {
  margin-top: 3px;
  border-right: 2px;
  margin-right: -9px;
  position: relative;
  width: 18px;
  height: 18px;
  background: linear-gradient(
    180deg,
    #f44336,
    #f44336 44%,
    white 57%,
    white 50%,
    #f44336 50%
  );
  /*border-radius: 50%;*/
}

.pokemon-ball-green {
  margin-top: 3px;
  border-right: 2px;
  margin-right: -9px;
  position: relative;
  width: 18px;
  height: 18px;
  background: linear-gradient(
    180deg,
    #4caf50,
    #4caf50 44%,
    white 57%,
    white 50%,
    #4caf50 50%
  );
  /*border-radius: 50%;*/
}

.pokemon-ball-half {
  margin-top: 3px;
  border-right: 2px;
  margin-right: -9px;
  position: relative;
  width: 18px;
  height: 18px;
  background: linear-gradient(
    180deg,
    #4caf50,
    #4caf50 44%,
    white 57%,
    white 50%,
    #f44336 50%
  );
  /*border-radius: 50%;*/
}

.pokemon-ball-none {
  margin-top: 3px;
  margin-right: -9px;
  position: relative;
  width: 18px;
  height: 18px;
  /*background: white;*/
  border-right: 2px;
}

.popup-content {
  position: absolute;
  padding: 8px;
  top: -8px;
  right: 14px;
  z-index: 10001;
  /*border-radius: 5px;*/
  background-color: #fff;
  border: solid 1px #e4e8ea;
  /*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  width: max-content;
}

.table-responsive {
  margin-bottom: 0px;
  border-radius: 5px;
}

.loss {
  color: #f44336;
  font-weight: bold;
  /*  font-size:10px;*/
}

.win {
  color: #4caf50;
  font-weight: bold;
  /*  font-size: 10px;*/
}
.time-text-sig {
  font-weight: 400;
  vertical-align: middle;
  /*  font-size: 12px;*/
}
.mini-flag {
  margin-bottom: -2px;
}

.mini-flag-il {
  margin-bottom: -1px;
  margin-left: 6px;
}

.missed-call {
  background-color: rgb(239, 61, 55);
  animation: flash 1s linear infinite;
}
@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

.auto-missed-call {
  background-color: #a5011f;
  animation: flash 2s linear infinite;
}
@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

.ca-coming {
  background-color: rgb(255 164 0);
}
.now-color {
  margin-top: 0.2em;
  color: #4caf50;
  font-weight: 800;
}
</style>
